import ApiService from "./ApiService";

const DesvincularService = async () => {
  let pathUrl = `${process.env.REACT_APP_APIPAYWALL}Cliente/DesasociarCredencial`;
  return ApiService.post(pathUrl, {});
};

export default DesvincularService;
